
export default {
    blankQuestion: null,
    parsedQuestions: null,
    
    selectedCohortId: null,
    selectedTermId: null,
    selectedSubjectId: null,
};